/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClientManagementGetOtDocsGet$Params {
  otRepository?: string;
}

export function clientManagementGetOtDocsGet(http: HttpClient, rootUrl: string, params?: ClientManagementGetOtDocsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetOtDocsGet.PATH, 'get');
  if (params) {
    rb.query('otRepository', params.otRepository, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

clientManagementGetOtDocsGet.PATH = '/ClientManagement/GetOtDocs';
